import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../public/images/my-photo.png'


const _hoisted_1 = { class: "hidden xl:flex xl:max-w-none" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "translate-z-0 w-full h-full",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}